import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";
import Select from "react-select";
import * as XLSX from "xlsx";

export default function PaidDetail() {
    const { http, user } = AuthUser();
    const [tasks, setTasks] = useState([]);
    const [summary, setSummary] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const [paidDateStart, setPaidDateStart] = useState("");
    const [paidDateEnd, setPaidDateEnd] = useState("");
    const [selectedClassStud, setselectedClassStud] = useState("");
    const [selectedDevStud, setselectedDevStud] = useState("");
    const [selectedDevStudType, setselectedDevStudType] = useState("");
    const [selectedDevStudAgentType, setselectedDevStudAgentType] = useState("");
    const [selectedStud, setSelectedStudent] = useState("");

    const [stClass, setStClass] = useState([]);
    const [stDev, setstDev] = useState([]);
    const [stYear, setstYear] = useState([]);
    const [selectedDevYear, setselectedDevYear] = useState("");
    const [fees, setFeesList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [stAgent, setstAgent] = useState([]);
    const [allStudent, setAllStudent] = useState([]);
    const [companyInfo, setCompanyInfo] = useState(null);

    useEffect(() => {
        http.get(`/class?company_id=${user.company_id}`).then((res) => {
            setStClass(res.data.data);
        });
        http.get(`/devision`).then((res) => {
            setstDev(res.data.data);
        });
        http.get(`/year?login_user=${user.id}`).then((res) => {
            setstYear(res.data.data);
        });
        http.get(`/agent?company_id=${user.company_id}`).then((res) => {
            setstAgent(res.data.data);
        });
        http.get(`/student_all?company_id=${user.company_id}`).then((res) => {
            setAllStudent(res.data.data);
        });
        http.get(`/companyinfo?login_user=${user.id}`).then((res) => {
            if (res.data.data && res.data.data.length > 0) {
                setCompanyInfo(res.data.data[0]);
            }
        });
    }, []);

    const fetchData = () => {
        if (!paidDateStart || !paidDateEnd) {
            toast.error("Please select both Paid Date From and To");
            return;
        }
        setIsLoading(true);
        const student = selectedStud ? selectedStud.value : "";
        let endpoint = `/paid_fee_details?paid_start_date=${paidDateStart}&paid_end_date=${paidDateEnd}&class=${selectedClassStud}&dev=${selectedDevStud}&type=${selectedDevStudType}&student=${student}&company_id=${user.company_id}&agent=${selectedDevStudAgentType}`;

        http.get(endpoint)
            .then((res) => {
                setIsLoading(false);
                if (Array.isArray(res.data.data)) {
                    setTasks(res.data.data);
                }
                if (res.data.summary) {
                    setSummary(res.data.summary);
                }
            })
            .catch(() => {
                setIsLoading(false);
                toast.error("Error fetching data");
            });
    };

    const formatNumber = (num) => {
        if (!num || num === 0) return "";
        return parseFloat(num).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const buildGroupedData = (data) => {
        const groups = {};
        data.forEach(task => {
            const studentName = `${task.first_name || ''} ${task.last_name || ''}`.trim();
            const feeType = task.fees_name ? task.fees_name.name : 'N/A';
            const key = `${task.adm_no}__${task.class}__${feeType}`;
            if (!groups[key]) {
                groups[key] = {
                    admNo: task.adm_no,
                    student: studentName,
                    class: task.class,
                    div: task.dev,
                    feeType,
                    masterAmt: task.annual_data ? parseFloat(task.annual_data.amount || 0) : 0,
                    totalPaid: task.annual_data ? parseFloat(task.annual_data.ext_6 || 0) : 0,
                    paidAmt: 0,
                    lastDate: task.alt_date || task.created_at,
                };
            }
            groups[key].paidAmt += parseFloat(task.amount) || 0;
            const taskDate = task.alt_date || task.created_at;
            if (taskDate > groups[key].lastDate) groups[key].lastDate = taskDate;
        });
        return Object.values(groups).sort((a, b) =>
            a.student.localeCompare(b.student) || a.class.localeCompare(b.class) || a.feeType.localeCompare(b.feeType)
        );
    };

    const groupedData = buildGroupedData(tasks);

    const options = allStudent.map((u) => ({
        value: u.id,
        label: `${u.adm_no} - ${u.ext_2}${u.ext_3} - ${u.class}${u.section} - ${u.mobile}`,
    }));

    const handleSelectChangeYear = (event) => {
        setselectedDevYear(event.target.value);
        http.get(`/tution_feeslists?company_id=${user.company_id}&year=${event.target.value}`)
            .then((res) => {
                setFeesList(res.data.data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    };

    const handleClear = () => {
        window.location.reload();
    };

    const handlePrint = () => {
        const printContent = document.getElementById("paidDetailTable");
        if (!printContent) return;
        const win = window.open("", "", "width=1200,height=800");
        win.document.write(`
            <html><head><title>Paid Details Report</title>
            <style>
                body { font-family: Arial, sans-serif; font-size: 12px; margin: 20px; }
                table { width: 100%; border-collapse: collapse; }
                th, td { border: 1px solid #ccc; padding: 5px 8px; text-align: left; }
                th { background: #f0f0f0; font-weight: bold; }
                .text-end { text-align: right; }
                h4, h6 { text-align: center; margin: 5px 0; }
                .summary-row { font-weight: bold; background: #f9f9f9; }
            </style>
            </head><body>
            <h4>${companyInfo ? companyInfo.company_name : ''}</h4>
            <h6>Paid Details Report | ${paidDateStart ? moment(paidDateStart).format("DD-MM-YYYY") : ''} to ${paidDateEnd ? moment(paidDateEnd).format("DD-MM-YYYY") : ''}</h6>
            ${printContent.outerHTML}
            </body></html>
        `);
        win.document.close();
        win.print();
    };

    const convertToExcel = () => {
        if (tasks.length === 0) {
            toast.error("No data to export");
            return;
        }
        const excelData = groupedData.map((group, index) => ({
            'No': index + 1,
            'Adm No': group.admNo,
            'Student': group.student,
            'Class': group.class,
            'Div': group.div,
            'Fee Type': group.feeType,
            'Master Amt': group.masterAmt,
            'Due': (group.masterAmt - group.totalPaid).toFixed(2),
            'Paid Amt': group.paidAmt.toFixed(2),
        }));

        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Paid Details");
        XLSX.writeFile(wb, `paid_details_${moment().format('YYYY-MM-DD')}.xlsx`);
        toast.success("Exported successfully!");
    };

    return (
        <>
            <div className="container-fluid px-0">
                <Toaster position="top-right" reverseOrder={false} />

                <div className="row mt-3 px-4 align-items-center">
                    <div className="col-md-6">
                        <h5 className="mb-0">
                            <Link to="/duelist" className="text-decoration-none text-muted me-2">
                                <i className="fas fa-arrow-left"></i>
                            </Link>
                            Paid Fee Details
                        </h5>
                    </div>
                </div>

                <div className="row mt-3 px-4 align-items-end">
                    <div className="col-md-2">
                        <label className="small text-muted mb-1">Class</label>
                        <select onChange={(e) => setselectedClassStud(e.target.value)} className="form-control">
                            <option value="">All</option>
                            {stClass.map((option, index) => (
                                <option key={index} value={option.class_name}>{option.class_name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-1">
                        <label className="small text-muted mb-1">Div</label>
                        <select onChange={(e) => setselectedDevStud(e.target.value)} className="form-control">
                            <option value="">All</option>
                            {stDev.map((option, index) => (
                                <option key={index} value={option.name}>{option.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-1">
                        <label className="small text-muted mb-1">Year</label>
                        <select onChange={handleSelectChangeYear} className="form-control border border-danger">
                            <option value="">Year</option>
                            {stYear.map((option, index) => (
                                <option key={index} value={option.name}>{option.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-2">
                        <label className="small text-muted mb-1">Fees Type</label>
                        <select onChange={(e) => setselectedDevStudType(e.target.value)} className="form-control">
                            {loading ? <option>Loading...</option> : (
                                <>
                                    <option value="">All</option>
                                    {fees.map((option, index) => (
                                        <option key={index} value={option.id}>{option.name}</option>
                                    ))}
                                </>
                            )}
                        </select>
                    </div>
                    <div className="col-md-2">
                        <label className="small text-muted mb-1">Agent</label>
                        <select onChange={(e) => setselectedDevStudAgentType(e.target.value)} className="form-control">
                            <option value="">All</option>
                            {stAgent.map((option, index) => (
                                <option key={index} value={option.id}>{option.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label className="small text-muted mb-1">Student</label>
                        <Select
                            options={options}
                            onChange={setSelectedStudent}
                            value={selectedStud}
                            placeholder="Search Student..."
                            isClearable
                        />
                    </div>
                </div>

                <div className="row mt-2 px-4 align-items-end">
                    <div className="col-md-2">
                        <label className="small text-muted mb-1">Paid Date From</label>
                        <input type="date" className="form-control border-success" onChange={(e) => setPaidDateStart(e.target.value)} />
                    </div>
                    <div className="col-md-2">
                        <label className="small text-muted mb-1">Paid Date To</label>
                        <input type="date" className="form-control border-success" onChange={(e) => setPaidDateEnd(e.target.value)} />
                    </div>
                    <div className="col-md-8 d-flex gap-2 align-items-end">
                        <button className="btn btn-sm btn-primary" onClick={fetchData}>
                            <i className="fas fa-search me-1"></i>Search
                        </button>
                        <button className="btn btn-sm btn-secondary" onClick={handleClear}>
                            <i className="fas fa-redo me-1"></i>Clear
                        </button>
                        <button className="btn btn-sm btn-success" onClick={convertToExcel}>
                            <i className="fas fa-download me-1"></i>Export
                        </button>
                        <button className="btn btn-sm btn-info text-white" onClick={handlePrint}>
                            <i className="fas fa-print me-1"></i>Print
                        </button>
                    </div>
                </div>

                <hr className="mx-4" />

                <div className="row px-4">
                    {isLoading ? (
                        <TaskSkeleton />
                    ) : tasks.length === 0 ? (
                        <div className="alert alert-warning" role="alert">
                            Select paid date range and click Search to view paid details.
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table id="paidDetailTable" className="table table-sm mt-2" style={{ fontSize: '0.78rem' }}>
                                <thead className="table-success">
                                    <tr>
                                        <th style={{ width: '3%' }}>No</th>
                                        <th style={{ width: '8%' }}>Adm No</th>
                                        <th style={{ width: '18%' }}>Student</th>
                                        <th style={{ width: '6%' }}>Class</th>
                                        <th style={{ width: '5%' }}>Div</th>
                                        <th style={{ width: '14%' }}>Fee Type</th>
                                        <th style={{ width: '12%' }}>Master Amt</th>
                                        <th style={{ width: '12%' }}>Due</th>
                                        <th style={{ width: '12%' }}>Paid Amt</th>
                                    </tr>
                                    <tr className="table-light">
                                        <th colSpan={6} className="text-end"><b>Totals:</b></th>
                                        <th className="text-end"><b>{formatNumber(groupedData.reduce((s, g) => s + g.masterAmt, 0))}</b></th>
                                        <th></th>
                                        <th className="text-end"><b>{formatNumber(summary.total_paid)}</b></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {groupedData.map((group, index) => {
                                        const due = group.masterAmt - group.totalPaid;
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{group.admNo}</td>
                                                <td style={{ whiteSpace: 'nowrap' }}>{group.student}</td>
                                                <td>{group.class}</td>
                                                <td>{group.div}</td>
                                                <td>{group.feeType}</td>
                                                <td className="text-end">{formatNumber(group.masterAmt)}</td>
                                                <td className="text-end" style={{ color: due > 0 ? '#d32f2f' : '#2e7d32' }}><b>{formatNumber(due)}</b></td>
                                                <td className="text-end"><b>{formatNumber(group.paidAmt)}</b></td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
